<template>
  <div class="credit-page">
    <div class="clear">
      <h2 class="paging-title">我的额度</h2>
    </div>
    <div class="info-wrapper">
      <div class="flex">
        <div class="info-item">
          <span class="label">我的额度：</span>
          <span class="price">
            <i class="unit">￥</i>
            {{accountBalance.CreditLineTotalValue | formatPrice}}
          </span>
        </div>
        <div class="info-item">
          <span class="label">剩余额度：</span>
          <span class="price">
            <i class="unit">￥</i>
            {{accountBalance.CreditLineMpValue | formatPrice}}
          </span>
        </div>
      </div>
      <p class="desc">为了保证您账户额度的安全，如需提现，请致电速派客服进行申请和审核：021-60956592</p>
    </div>
    <div class="filter-area">
      <div class="filter-item">
        <span class="label">时间：</span>
        <el-date-picker
          size="mini"
          v-model="startTime"
          :picker-options="startOption"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期">
        </el-date-picker>
        <span class="unit">至</span>
        <el-date-picker
          size="mini"
          v-model="endTime"
          :picker-options="endOption"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期">
        </el-date-picker>
        <button class="btn-primary" @click="search">查询</button>
      </div>
      <div class="filter-item">
        <span class="label">分类：</span>
        <ul class="tab-hd">
          <li v-for="item in tabHd" :key="item.id" :class="{on:item.id==tabId}" @click="tabChange(item.id)">{{item.text}}</li>
        </ul>
      </div>
    </div>
    <table class="table">
      <tr>
        <th>时间</th>
        <th>类别</th>
        <th>收支（元）</th>
        <th>详情</th>
      </tr>
      
      <tr v-for="(item,index) in tableData" :key="index">
        <td>{{item.TradeDate}}&nbsp;{{item.TradeTime}}</td>
        <td>{{item.TradeType}}</td>
        <td>
          <span :class="{red:item.Money>0,green:item.Money<0}">{{item.Money}}</span>
        </td>
        <td>
          <div>{{item.PayStatus}}</div>
          <div>{{item.Content}}</div>
          <div v-if="item.JobNo">工单号：{{item.JobNo}}</div>
        </td>
      </tr>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>
<script>
import {
  ListTradeRecordByPC,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  data(){
    return{
      dateRange:[],
      tabHd:[{
        text:'全部',
        id:0,
      },{
        text:'收款',
        id:3,
      },{
        text:'支付',
        id:4,
      }],
      tableData:[],
      tabId:0,
      startTime:'',
      endTime:'',
      pageNum:1,
      pageSize:10,
      total:0,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
      accountBalance:state=>state.accountBalance
    }),
    startOption(){
      //开始时间不可选择的日期
      let obj={disabledDate:null};
      let that=this;
      if(that.endTime){
        obj={
          disabledDate(time) {
            return time.getTime() > new Date(that.endTime).getTime();
          }
        }
      }else{
        obj={
          disabledDate(time) {
            return time.getTime() >  Date.now();
          }
        }
      }
      return obj;
    },
    endOption(){
      //结束时间不可选择的日期
      let obj={disabledDate:null};
      let that=this;
      if(that.startTime){
        obj={
          disabledDate(time) {
            return time.getTime() < new Date(that.startTime).getTime() || time.getTime() >  Date.now();
          }
        }
      }else{
        obj={
          disabledDate(time) {
            return time.getTime() >  Date.now();
          }
        }
      }
      return obj;
    }
  },
  created() {
    this.tabChange(this.tabId);
  },
  mounted() {
    this.$store.dispatch('loadAccountBalance');
  },
  methods: {
    tabChange(id){
      this.tabId=id;
      this.loadList();
    },
    search(){
      this.pageNum=1;
      this.loadList();
    },
    //分页
    pageChange(data){
      this.pageNum=data;
      this.loadList();
    },
    //获取明细列表
    loadList(){
      ListTradeRecordByPC({
        UserCode:this.userInfo.UserCode,
        StartTime:this.startTime,
        EndTime:this.endTime,
        PageSize:this.pageSize,
        PageNo:this.pageNum,
        TradeTypeStr:this.tabId===0?'':this.tabId+'',
      }).then(r=>{
        if(r.Result==1){
          this.tableData = r.Data.TradeRecords || [];
          this.total = r.Data.TotalCounts;
          this.$forceUpdate();
        }
      })
    }
  },
}
</script>
<style lang="scss">
.credit-page{
  .info-wrapper{
    background: #f9f9f9;
    padding: 25px 22px;
    position: relative;
    margin-bottom: 30px;
    margin-top: 20px;
    .info-item{
      display: inline-block;
      margin-right: 20px;
      .label{
        font-size: 14px;
        color: #333;
        line-height: 24px;
      }
      .price{
        font-size: 16px;
        color: #f75959;
        line-height: 24px;
        font-weight: bold;
        font-family: "DIN-Regular";
      }
      .unit{
        font-weight: normal;
        font-size: 12px;
      }
    }
    .desc{
      font-size: 12px;
      color: #999;
      line-height: 24px;
    }
  }
  .filter-area{
    background: #f9f9f9;
    padding: 25px 22px 5px 22px;
    position: relative;
    margin-bottom: 30px;
    .filter-item{
      overflow: hidden;
      margin-bottom: 20px;
    }
    .label{
      float: left;
      font-size: 14px;
      color: #333;
      line-height: 28px;
      margin-right: 10px;
    }
    .el-input{
      width: 160px;
    }
    .unit{
      font-size: 14px;
      color: #999;
      line-height: 28px;
      padding-left: 5px;
      padding-right: 5px;
    }
    .btn-primary{
      width: 60px;
      text-align: center;
      line-height: 26px;
      border: 0;
      margin-left: 20px;
    }
    .tab-hd{
      overflow: hidden;
      float: left;
      >li{
        float: left;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color: #999;
        padding: 0 16px;
        margin-right: 15px;
        cursor: pointer;
        user-select: none;
        &.on{
          background-color: #f75959;
          color: #fff;
          border-radius: 2px;
        }
      }
    }
  }
  .table{
    width: 100%;
    border-collapse: collapse;
    th{
      font-size: 14px;
      color: #999;
      line-height: 30px;
      border-bottom: 1px solid #f75959;
      text-align: left;
      padding-left: 10px;
      padding-right: 10px;
      height: 50px;
    }
    td{
      padding: 5px 10px;
      border-bottom: 1px solid #e5e5e5;
      font-size: 14px;
      color: #666;
      line-height: 24px;
      text-align: left;
      height: 80px;
    }
    .red{
      color: #f75959;
    }
    .green{
      color: #15d964;
    }
  }
  .el-pagination{
    text-align: right;
    margin-top: 20px;
  }
}
</style>